// removed by extract-text-webpack-plugin
module.exports = {"leftNav":"PageLabel__leftNav___1mA9g","contentWithLeftNav":"PageLabel__contentWithLeftNav___fumhJ","chapter":"PageLabel__chapter___SBoIL","chapterHeader":"PageLabel__chapterHeader___3xLzQ","chapterTitle":"PageLabel__chapterTitle___22AFi","chapterSubtitle":"PageLabel__chapterSubtitle___3Swti","nonIdeal":"PageLabel__nonIdeal___20OAt","noDataMessage":"PageLabel__noDataMessage___2LL_T","pageLabel":"PageLabel__pageLabel___2Jprh","text":"PageLabel__text___U-kkS"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/PageLabel.css
// module id = 1567
// module chunks = 0